var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MountingPortal',{attrs:{"mountTo":"body","append":""}},[_c('div',{staticClass:"z-5000 fixed inset-0 flex items-center justify-center",staticStyle:{"background":"rgba(20, 28, 33, 0.5)"}},[_c('Spinner',{attrs:{"size":"8xl"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }